import {
  ListOwnersEditorActionTypes,
  ListOwnersEditorActions,
} from './list-owners-editor.actions';
import {
  LIST_OWNERS_EDITOR_INITIAL_STATE,
  ListOwnersEditorState,
} from './list-owners.state';

export function listOwnersEditorReducer(
  state: ListOwnersEditorState = LIST_OWNERS_EDITOR_INITIAL_STATE,
  action: ListOwnersEditorActions,
): ListOwnersEditorState {
  switch (action.type) {
    case ListOwnersEditorActionTypes.LIST_OWNERS_EDITOR_SHOW_MODAL: {
      return {
        ...LIST_OWNERS_EDITOR_INITIAL_STATE,
        listId: action.payload.listId,
        isModalShown: true,
      };
    }

    case ListOwnersEditorActionTypes.LIST_OWNERS_EDITOR_SAVE: {
      return {
        ...state,
        isSaving: true,
        savingError: null,
      };
    }

    case ListOwnersEditorActionTypes.LIST_OWNERS_EDITOR_SAVE_FAILED: {
      return {
        ...state,
        isSaving: false,
        savingError: action.payload.error,
      };
    }

    case ListOwnersEditorActionTypes.LIST_OWNERS_EDITOR_HIDE_MODAL:
    case ListOwnersEditorActionTypes.LIST_OWNERS_EDITOR_SAVE_SUCCEEDED: {
      return LIST_OWNERS_EDITOR_INITIAL_STATE;
    }

    default: {
      return state;
    }
  }
}
